<template>
  <div class="results-wrapper-mobile min-h-[100vh]">
    <ResultsComponentMobile />
  </div>
</template>

<script>
import ResultsComponentMobile from '@/components/mobile/ResultsComponent.vue';

export default {
  name: 'ResultsWrapperMobile',
  components: {
    ResultsComponentMobile,
  },
};
</script>

<style scoped>
.results-wrapper-mobile {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  min-height: calc(100vh - 180px);
  box-sizing: border-box;
}
</style>
